var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3237 2.5C14.5821 2.5 18.0663 5.875 18.0663 10C18.0663 14.125 14.5821 17.5 10.3237 17.5C6.06522 17.5 2.58103 14.125 2.58103 10C2.58103 5.875 6.06522 2.5 10.3237 2.5ZM10.3237 1.25C5.35548 1.25 1.29059 5.1875 1.29059 10C1.29059 14.8125 5.35548 18.75 10.3237 18.75C15.2919 18.75 19.3568 14.8125 19.3568 10C19.3568 5.1875 15.2919 1.25 10.3237 1.25Z",
    fill: "#2D91E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4854 9.375H10.9688V5H9.67841V9.375H5.16187V10.625H9.67841V15H10.9688V10.625H15.4854V9.375Z",
    fill: "#2D91E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.f9d476fccd9b89d366b9765b2afa0d35.svg";
export { ForwardRef as ReactComponent };